import cn from 'classnames';
import React, { useState, useRef, useEffect } from 'react';
import * as PropTypes from 'prop-types';

import Button from '../../../../Button';
import Icon from '../../../../Icon';

import { getLinkProps } from './utils/getLinkProps';

import styles from './index.styl';

const CustomButtons = ({
  additionalButtonStyles = '',
  customButtons,
  isFullWidthButton,
  formatMessage,
  isMenuBar,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  const onButtonClick = () => {
    setIsOpen(!isOpen);
  };

  const buttonAdditionalTitle = formatMessage({
    id: 'healthboard.buttons.additionalResources',
  });

  useEffect(() => {
    const handleClickOutside = event => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, []);

  if (!customButtons.length) {
    return null;
  }

  if (isMenuBar) {
    return (
      <div
        className={cn(styles.buttonContainer, additionalButtonStyles)}
        ref={menuRef}
      >
        <Button
          color="accent"
          raised
          onClick={onButtonClick}
          className={styles.menuButton}
          border
        >
          {isFullWidthButton ? (
            buttonAdditionalTitle
          ) : (
            <Icon name="three-dots-16" size={16} />
          )}
        </Button>
        {isOpen && (
          <div
            className={cn(styles.dropdownMenu, {
              [styles.dropdownMenuFullWidth]: isFullWidthButton,
            })}
          >
            {customButtons.map(item => {
              const { target, href } = getLinkProps(item);

              return (
                <a
                  key={item.id}
                  href={href}
                  target={target}
                  rel="noopener noreferrer"
                  className={styles.dropdownItem}
                >
                  {item.name}
                </a>
              );
            })}
          </div>
        )}
      </div>
    );
  }

  return (
    <div
      className={cn(styles.listItems, {
        [styles.mobileList]: isFullWidthButton,
      })}
    >
      {customButtons.map(item => {
        const { target, href } = getLinkProps(item);

        return (
          <a
            key={item.id}
            href={href}
            target={target}
            rel="noopener noreferrer"
            className={cn({
              [styles.mobileButton]: isFullWidthButton,
            })}
          >
            <Button
              raised
              color="primary"
              className={cn(styles.listButton, {
                [styles.mobileButton]: isFullWidthButton,
              })}
            >
              {item.name}
            </Button>
          </a>
        );
      })}
    </div>
  );
};

CustomButtons.propTypes = {
  additionalButtonStyles: PropTypes.string,
  customButtons: PropTypes.array,
  isFullWidthButton: PropTypes.bool,
  isMenuBar: PropTypes.bool,
  formatMessage: PropTypes.func,
};

export default CustomButtons;



// WEBPACK FOOTER //
// ./src/components/Healthboard/HealthboardHome/components/CustomButtons/index.jsx